import styled from 'styled-components';
import { COLOR_WHITE } from '../../../assets/styles/colors';
import { BP_TABLET_MAX } from '../../../assets/styles/breakpoints';

export default styled.tr`
  background: ${COLOR_WHITE};
  &:first-child {
    td {
      &:first-child {
        border-top-left-radius: 0px;
      }
      &:last-child {
        border-top-right-radius: 0px;
      }
    }
  }
  &:last-child {
    td {
      &:first-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-left-radius: 12px;`)}
      }
      &:last-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-right-radius: 12px;`)}
      }
      &:after {
        display: none;
      }
    }
  }
  &:hover {
    td {
      background: #f8f8f9;
    }
  }
  td {
    text-align: center;
    position: relative;
    max-width: 200px;
    height: 60px;

    &.button-cell {
      max-width: 110px;
    }

    .cancel-button {
      min-width: 110px;
    }

    a {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    a:hover {
      text-decoration: none;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0px;
      height: 1px;
      width: 100%;
      background: rgba(47, 46, 65, 0.1);
      left: 0;
    }
    &:first-child {
      a {
        padding-left: 32px;
      }
      &:after {
        right: 0px;
        left: auto;
      }
    }
    &:nth-child(6) {
      width: 50px;
      .bid-counter {
        position: relative;
        margin-left: 8px;
        margin-right: 28px;
        display: inline-block;
        small {
          position: absolute;
          right: -12px;
          top: -5px;
          height: 20px;
          width: 20px;
          border-radius: 20px;
          background: linear-gradient(180deg, #fc3e65 0%, #e71b5d 100%);
          color: white;
          font-size: 14px;
          font-weight: bold;
          z-index: 1;
          display: flex;
          justify-content: center;
        }
        svg {
          z-index: 0;
          opacity: 1;
        }
        &.disabled {
          svg {
            opacity: 0.2;
          }
        }
      }
    }
    &:last-child {
      a {
        padding-right: 32px;
      }
      text-align: right;
      width: 50px;
      &:after {
        right: auto;
        left: 0px;
      }
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    display: flex;
    margin-bottom: 16px;
    box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
    border-radius: 12px;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    td {
      max-width: 100%;
      width: 100%;
      padding: 0px 0px;
      &:after {
        display: none;
      }

      &.button-cell {
        max-width: none;
      }

      a {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      &:first-child {
        padding: 0;
        a {
          padding-top: 24px;
          padding-left: 16px;
          padding-right: 16px;
          width: 100%;
        }
      }
      &:nth-child(2) {
        padding: 0;
        a {
          padding-top: 8px;
          padding-left: 16px;
          padding-right: 16px;
          width: 100%;
        }
      }
      &:last-child {
        height: 100%;
        padding-top: 15px;
        padding-bottom: 24px;
        padding-left: 16px;
        padding-right: 16px;
        width: 100%;
        button {
          width: 100%;
        }
      }
    }
  }
`;
